module.exports = __webpack_public_path__ + "static/img/zh.57d21d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/zh.png
// module id = QXeX
// module chunks = 1